import { PageTable, Header } from "/src/layouts/page";
import SliderTab from "/src/components/slider/sliderTab";
import hasPermission from "/src/utils/hasPermission";
import CompanyTable from "/src/features/administration/company/components/CompanyTable/CompanyTable";
import UserTable from "/src/features/administration/user/components/UserTable/UserTable";
import RoleTable from "/src/features/administration/role/components/RoleTable/RoleTable";
import PhoneTable from "/src/features/administration/phone/components/PhoneTable/PhoneTable";
import "../configuration.css";

function ConfigurationPage() {
    const items = [
        hasPermission("view_organizations") ? { name: "Organizations", component: <CompanyTable bare /> } : null,
        hasPermission("view_users") ? { name: "Users", component: <UserTable bare /> } : null,
        hasPermission("view_roles") ? { name: "Roles", component: <RoleTable bare /> } : null,
        hasPermission("view_phones") ? { name: "Phones", component: <PhoneTable bare /> } : null,
    ].filter((item) => item);

    return (
        <PageTable>
            <Header title="Configuration"></Header>
            <div className="administration-configuration-page">
                <SliderTab items={items} name="configuration" type="tab" />
            </div>
        </PageTable>
    );
}

export default ConfigurationPage;
